import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import LanguageStrings from '../../../i18n/locales'

const AddDeviceComponent = LanguageStrings().DeviceManagementCollectionStrings.AddDeviceComponent

// Define schemas using Zod
const ZUpdateEmailGroupResponse = z.object({
  groupName: z.string(),
  tenantId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  modifiedBy: z.string(),
  enabled: z.boolean()
})

const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: ZUpdateEmailGroupResponse,
  error_message: z.optional(z.string())
})

// Export types derived from Zod schemas
export type UpdateEmailGroupResponse = z.infer<typeof ZUpdateEmailGroupResponse>
export type ApiResponse = z.infer<typeof ZApiResponse>

export interface UpdateEmailGroupRequest {
  groupName: string
  siteIds: string[]
  severityIds: string
  distributionList: string
  enabled: boolean
  tenantId: string
}

export async function updateEmailGroup (
  groupId: string,
  updateRequest: UpdateEmailGroupRequest,
  onSuccess: (response: UpdateEmailGroupResponse, httpStatus: number) => void,
  onFailure: (errorMessage: any, httpStatus: number) => void
): Promise<void> {
  const url = `/communications-service/api/v1/udp/tiq/services/email/edit-group/${groupId}`
  interceptedAxios
    .put(url, updateRequest, { timeout: 15000 })
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      if (parseResponse.success) {
        onSuccess(parseResponse.data.data, parseResponse.data.http_status)
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.data.http_status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure(AddDeviceComponent.NetworkError, error.status)
      }
    })
}
